import { Button } from '@mui/material'
import React from 'react'
import DeleteModalProps from '../interfaces/DeleteModalProps'

const DeleteModal: React.FC<DeleteModalProps> = ({ setConfirmDelete, setShowDelete }) => {

  const handleDeleteAction = async (doDelete: boolean) => {
    try {
      if (doDelete)
        setConfirmDelete(true);
    }
    catch {
      console.error("No se pudo borrar");
    }
    setShowDelete(false);
  };

  return (
    <div className="modal">
      <div className="modal-content delete-modal">
        Estás seguro de querer eliminar tu reseña?
        <section>
          <Button type="button" onClick={() => handleDeleteAction(true)}>Si</Button>
          <Button type="button" onClick={() => handleDeleteAction(false)}>No</Button>
        </section>
      </div>
    </div>
  )
}

export default DeleteModal
